import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { Button, Col, Row } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';

import { useToast } from '../../../hooks/toast';

import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import Loading from '../../../components/Loading';
import { IAgendaSala } from '..';
import Input from '../../../components/Input';

interface FormDados {
  NomeSala: string;
}
type ComponentProps = {
  agendaSala: IAgendaSala;
  salas: string[];
  handleAltera(agendaSala: IAgendaSala): void;
};
const ItemAgendaSalas: React.FC<ComponentProps> = ({
  agendaSala,
  salas,
  handleAltera,
}) => {
  const { addToast } = useToast();
  const formRefParcela = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const InitialData: FormDados = {
    NomeSala: agendaSala?.NomeSala || '',
  };

  const handleSubmit = useCallback(
    async (dados: FormDados) => {
      try {
        setLoading(true);

        const dadosSala: IAgendaSala = {
          ConCodigo: agendaSala.ConCodigo,
          ConNome: agendaSala.ConNome,
          NomeSala: dados.NomeSala,
        };
        await api.post(`/salas`, dadosSala);
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro alterar Sala',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, agendaSala],
  );

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      <Form
        ref={formRefParcela}
        initialData={InitialData}
        onSubmit={handleSubmit}
      >
        <Row noGutters className="bg-light text-dark p-1">
          <Col md={1} className="px-1">
            {agendaSala.ConCodigo}
          </Col>
          <Col md={5} className="px-1">
            {agendaSala.ConNome}
          </Col>
          <Col md={4} className="px-1">
            <Input name="NomeSala" list={`Salas-${agendaSala.ConCodigo}`} />
            <datalist id={`Salas-${agendaSala.ConCodigo}`}>
              {salas.map(sl => (
                <option
                  key={`optSalas-${agendaSala.ConCodigo}-${sl}-${
                    Math.random() * 99999999
                  }`}
                  value={sl}
                >
                  {sl}
                </option>
              ))}
            </datalist>
          </Col>

          <Col
            md={2}
            className="d-flex justify-content-between align-items-center px-1"
          >
            <Button
              data-id={agendaSala.ConCodigo}
              type="submit"
              size="sm"
              style={{ padding: '1px 8px' }}
              className="bg-success"
            >
              <FaCheckCircle size={14} />
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default ItemAgendaSalas;
